module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0015.710e648a.jpg";